module.exports = __webpack_public_path__ + "img/register_st.b5d1313c.png";